import { useGetDocument } from "@/hooks/queryHooks/documentHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { documentRepo } from "@/repositories/documentRepo";
import { useUserStore } from "@/stores/userStore";
import { Link } from "react-router-dom";

export const DocumentSummaryItem = ({
  tenantId,
  documentId,
}: {
  tenantId: string;
  documentId: string;
  tenantCollection?: "tenant" | "agenda" | "agendaItem";
  parentId?: string;
}) => {
  const activeTeam = useUserStore((s) => s.activeTeam);
  const { data: doc } = useGetDocument(tenantId, documentId);
  const path =
    documentId && activeTeam !== "org"
      ? new AppUrlPath(tenantId).getDocumentPath(documentId)
      : "";

  const attachment = doc ? documentRepo.getLinkedAttachment(doc) : null;

  return (
    <Link className="block hover:underline" to={path}>
      {!documentId
        ? "Unknown"
        : doc
          ? doc.name + (attachment?.name ? ` (${attachment.name})` : "")
          : "Loading..."}
    </Link>
  );
};
